/** 讨论组
state: [{
    id: Number
    jid: String
    name: String
    avatar: String
    created_at: Date
    updated_at: Date
    users: []
}]
*/
import { createAction, createReducer } from 'redux-act';
import _ from 'underscore';

const initialState = [];

function _mapItem(obj) {
    return _.extend({
        created_at: new Date(),
        updated_at: new Date(),
        user_ids: []
    }, obj);
}

function _addOrEdit(state, obj) {
    let item = _.find(state, { jid: obj.jid });
    if (item) {
        _.extend(item, _mapItem(_.extend({}, item, obj)));
    } else {
        state.push(_mapItem(obj));
    }
}

export const add = createAction('add');
export const edit = createAction('edit');
export const addOrEdit = createAction('addOrEdit');
export const remove = createAction('remove');
export const clear = createAction('clear');
export const editUser = createAction('editUser');
export const removeUser = createAction('removeUser');

export default createReducer({
    [add]: (state, obj) => {
        let arr;
        if (_.isArray(obj)) {
            arr = _.map(obj, (item) => {
                return _mapItem(item);
            });
        } else {
            arr = [_mapItem(obj)];
        }

        return [
            ...arr,
            ...state
        ];
    },

    [edit]: (state, obj) => state.map(item => {
        return item.jid === obj.jid ? _.extend(item, _mapItem(obj)) : item;
    }),

    [addOrEdit]: (state, obj) => {
        if (_.isArray(obj)) {
            _.each(obj, (item) => {
                _addOrEdit(state, item);
            });
        } else {
            obj && _addOrEdit(state, obj);
        }
        return [...state];
    },

    [remove]: (state, jid) => state.filter(item =>
        item.jid !== jid
    ),

    [clear]: (state) => {
        state.length = 0;
        return [...state];
    },

    [editUser]: (state, user) => state.map(item => {
        let src = _.find(item.users, { jid: user.jid });
        src && (_.extend(src, user));
        return item;
    }),

    [removeUser]: (state, { jid, user_jid }) => state.filter(item => {
        return !(item.jid === jid && _.find(item.users, { jid: user_jid }));
    })
}, initialState);


// WEBPACK FOOTER //
// ./src/group/redux/index.js